export interface FolderRaw {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  status: string;
  parentId?: string | null;
  level?: number;
  breadcrumbs?: { id: string; name: string }[];
  childCount?: number;
}

export interface Folder {
  id: string;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  status: 'visible' | 'hidden' | 'archived';
  parentId?: string | null;
  level?: number;
  breadcrumbs?: { id: string; name: string }[];
  childCount?: number;
}
